import { EditorConfig, ParagraphNode, SerializedParagraphNode } from "lexical"

interface RgptParagraphNodeProps {
  style?: string
}
const RGPT_PARAGRAPH_NODE_TYPE = "rgpt-paragraph"

export class RgptParagraphNode extends ParagraphNode {
  style: string

  constructor(props?: RgptParagraphNodeProps) {
    super()

    this.style = props?.style || ""
  }

  static override getType() {
    return RGPT_PARAGRAPH_NODE_TYPE
  }

  static override importJSON(serializedNode: SerializedParagraphNode): ParagraphNode {
    return ParagraphNode.importJSON(serializedNode)
  }

  static override clone(node: RgptParagraphNode): RgptParagraphNode {
    return new RgptParagraphNode(node.__text)
  }

  override createDOM(config: EditorConfig): HTMLElement {
    const dom = document.createElement("div")
    const baseStyle = "place-items: baseline; font-size: 17px"
    dom.setAttribute("style", this.style.includes(baseStyle) ? this.style : `${this.style}; ${baseStyle}`)
    return dom
  }

  override exportJSON(): SerializedParagraphNode {
    return {
      ...super.exportJSON(),
      type: RGPT_PARAGRAPH_NODE_TYPE,
    }
  }
}

export default RgptParagraphNode
